module.exports = __webpack_public_path__ + "static/the-smartest-investment-book-youll-ever-read-150b0fa622fbd6d3dd4f6ffa84888fd0.jpg";